// @ts-check
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
// re-export the tanstack/vue-query composable functions
export { useQuery, useQueryClient, useMutation, keepPreviousData, useInfiniteQuery } from '@tanstack/vue-query';

// create a new query client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry:
        /** @param {import('axios').AxiosError|Error} error */
        (failureCount, error) => {
          // If the object does not exist, do not retry
          if ('response' in error && error.response?.status === 404) {
            return false;
          }

          // Retry up to 3 times, this is the default behavior
          return failureCount < 3;
        },
    },
  },
});

export function initTanstackQuery(vue) {
  vue.use(VueQueryPlugin, { queryClient });
}
